// 配置编译环境和线上环境之间的切换
// let iconfontVersion = ['567566_qo5lxgtishg', '891042_6optx3pjx5a'];
// let iconfontUrl = `//at.alicdn.com/t/font_$key.css`;
// let codeUrl = `${baseUrl}/code`
// const env = process.env;
// //环境地址 配置在根目录.env.dev文件中
// let baseUrl = env.VUE_APP_API_URL;
// console.log(env.VUE_APP_API_URL,'env.VUE_APP_API_URL')
// export {
//     baseUrl,
//     iconfontUrl,
//     iconfontVersion,
//     codeUrl,
//     env
// }

// 配置编译环境和线上环境之间的切换

let baseUrl = '';
let iconfontVersion = ['567566_qo5lxgtishg', '891042_6optx3pjx5a'];
let iconfontUrl = `//at.alicdn.com/t/font_$key.css`;
let codeUrl = `${baseUrl}/code`
const env = process.env
//    baseUrl = `http://192.168.1.189:5200`; //开发
// baseUrl = `https://city.joinstech.com:8000`;
baseUrl = `https://huijia.joinstech.com`; 
// baseUrl = `https://sim.joinstech.com`;
// if (env.NODE_ENV == 'development') {
//     baseUrl = `http://192.168.3.100:5200`; // 开发环境地址
// } else if (env.NODE_ENV == 'production') {
//     baseUrl = `http://47.112.17.70`; //生产环境地址
// } else if (env.NODE_ENV == 'test') {
//     baseUrl = `http://192.168.3.100:5200`; //测试环境地址
// }
export {
    baseUrl,
    iconfontUrl,
    iconfontVersion,
    codeUrl,
    env
}

